// downgraded components from angular17
import { downgradeComponent } from '@angular/upgrade/static';
import { RouterOutletWrapperComponent } from '@shims';
import { VersionDisplayComponent } from '@ui-lib/components';
import { WidgetRefillResponseComponent } from '@widgets';
import * as angular from 'angular';
import pims from '../../angularJs/src/app/index.module.ajs';
import { StatusUpdateComponent } from './routes/gp-letters/components/buttons/status-update/status-update.component';
import { FiltersComponent } from './routes/gp-letters/components/filters/filters.component';
import { IncompleteAddressesComponent } from './routes/gp-letters/incomplete-addresses/incomplete-addresses.component';
import { PendingGpLettersComponent } from './routes/gp-letters/pending-gp-letters/pending-gp-letters.component';
import { UnresponsivePatientsComponent } from './routes/gp-letters/unresponsive-patients/unresponsive-patient.component';
import { UnverifiedAddressesComponent } from './routes/gp-letters/unverified-addresses/unverified-addresses.component';
import { HomeComponent } from './routes/home.component';
import { NewUserComponent } from './routes/users/new-user/new-user.component';
import { StaffUserComponent } from './routes/users/staff-users/staff-user/staff-user.component';
import { MedicationPhotoComponent } from './routes/visits/slugs/userId/tabs/medication-photo/medication-photo.component';
import { BiometricsContainerComponent } from './routes/visits/slugs/visitid/components/biometrics-container/biometrics-container.component';
import { ExamPhotosComponent } from './routes/visits/slugs/visitid/tabs/photos/identification/exam-photos/exam-photos.component';
import { IdPhotosComponent } from './routes/visits/slugs/visitid/tabs/photos/identification/id-photos/id-photos.component';
import { RefillsComponent } from './routes/visits/slugs/visitid/tabs/refills/refills.component';
import { WaitingRoomComponent } from './routes/visits/waiting-room/waiting-room.component';
import { MessageThreadComponent, MessagesComponent } from '@messaging';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { RxHubResentOrdersComponent } from './routes/visits/rx-hub/resent-orders/rx-hub-resent-orders.component';

export function loadDowngradedComponents() {
  pims.directive('idPhotos', downgradeComponent({ component: IdPhotosComponent }) as angular.IDirectiveFactory);
  pims.directive(
    'medicationPhoto',
    downgradeComponent({ component: MedicationPhotoComponent }) as angular.IDirectiveFactory,
  );
  pims.directive('examPhotos', downgradeComponent({ component: ExamPhotosComponent }) as angular.IDirectiveFactory);
  pims.directive(
    'statusUpdateButton',
    downgradeComponent({ component: StatusUpdateComponent }) as angular.IDirectiveFactory,
  );
  pims.directive('gpLettersFilters', downgradeComponent({ component: FiltersComponent }) as angular.IDirectiveFactory);
  pims.directive(
    'incompleteAddresses',
    downgradeComponent({ component: IncompleteAddressesComponent }) as angular.IDirectiveFactory,
  );
  pims.directive(
    'unresponsivePatients',
    downgradeComponent({ component: UnresponsivePatientsComponent }) as angular.IDirectiveFactory,
  );
  pims.directive(
    'unverifiedAddresses',
    downgradeComponent({ component: UnverifiedAddressesComponent }) as angular.IDirectiveFactory,
  );
  pims.directive(
    'pendingGpLetters',
    downgradeComponent({ component: PendingGpLettersComponent }) as angular.IDirectiveFactory,
  );
  pims.directive('newUser', downgradeComponent({ component: NewUserComponent }) as angular.IDirectiveFactory);
  pims.directive('staffUser', downgradeComponent({ component: StaffUserComponent }) as angular.IDirectiveFactory);
  pims.directive(
    'versionDisplay',
    downgradeComponent({ component: VersionDisplayComponent }) as angular.IDirectiveFactory,
  );
  pims.directive(
    'biometricsContainer',
    downgradeComponent({ component: BiometricsContainerComponent }) as angular.IDirectiveFactory,
  );
  pims.directive('waitingRoom', downgradeComponent({ component: WaitingRoomComponent }) as angular.IDirectiveFactory);
  pims.directive('pimsLogin', downgradeComponent({ component: HomeComponent }) as angular.IDirectiveFactory);
  pims.directive(
    'libWidgetRefillResponse',
    downgradeComponent({ component: WidgetRefillResponseComponent }) as angular.IDirectiveFactory,
  );
  pims.directive('refills', downgradeComponent({ component: RefillsComponent }) as angular.IDirectiveFactory);

  pims.directive(
    'routerOutletWrapper',
    downgradeComponent({ component: RouterOutletWrapperComponent }) as angular.IDirectiveFactory,
  );
  pims.directive(
    'pimsPatientMessages',
    downgradeComponent({
      component: MessageThreadComponent,
    }) as angular.IDirectiveFactory,
  );
  pims.directive('pimsInbox', downgradeComponent({ component: MessagesComponent }) as angular.IDirectiveFactory);
  pims.directive('rxHubResentOrders', downgradeComponent({ component: RxHubResentOrdersComponent }) as angular.IDirectiveFactory);
}
